import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Divider, Grid, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function createData(first, second){
    return {first, second};
}

const rows = [
    createData("Two-Year Certificate", 3),
    createData("Four-Year Diploma", 6),
    createData("Four-Year Bachelor’s", 6),
    createData("Five-Year Bachelor’s", "7½"),
]

function MRR() {
    return(
        <ThemeProvider theme={theme}>
            <NavbarDefault />
                <Grid         
                    container
                    direction="row"
                    justifyContent="center"
                    height="50%"
                    sx={{ flexGrow: 1, 
                    paddingBottom: 2,
                    paddingRight: 2,
                    marginTop: 2,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 5,
                    maxWidth: 1,
                    alignItems: "center"
                    }}
                    spacing={2}
                >
                    <Grid item xs={8} sx={{textAlign: 'justify'}}>
                        <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                            WHAT IS THE MAXIMUM RESIDENCY RULE?
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            The Maximum Residence Rule (MRR) states that students who fail to finish the requirements of a degree program of any college within a
                            prescribed period of actual residence shall not be allowed to register further in that college. Under meritorious cases, extension of residency
                            may be granted. The faculty of each college shall designate the approving authority for such extensions. Each extension granted shall be
                            reported to the Chancellor through the Vice Chancellor for Academic Affairs.<br/><br/>
                        </Typography>
                        <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>
                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            UNDERGRADUATE PROGRAM
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            The MRR states that students who fail to finish the requirements of a course of any college within a period of actual residence equivalent to
                            1½ times the normal length of the course concerned shall not be allowed to register further in the university.<br/><br/>

                            Thus, the prescribed years to finish a degree program for the undergraduate level are as follows:
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{textAlign: 'justify'}}>
                        <TableContainer component={Paper} sx={{flexGrow:1, maxWidth: "50vh"}}>
                            <Table sx={{width: 1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>Program</TableCell>
                                        <TableCell align='center'>Number of Years Allowed by MRR</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{row.first}</TableCell>
                                            <TableCell align='center'>{row.second}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={8} sx={{textAlign: 'justify'}}>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            However, Art. 243 of the Revised University Code should be taken into account in implementing the MRR for faculty, officers, and employees
                            of the University which states that “Members of the faculty, officers and employees shall have the privilege of enrolling in the University for
                            not more than nine (9) units at the undergraduate level or six (6) units at the graduate level in a semester at reduced rates in courses that
                            shall be beneficial to their regular work in the University or in their career development, subject to the approval of the Chancellor or his/her
                            authorized representative. In the case of non-teaching personnel, the courses shall be taken after office hours (Revised UP Code: Art. 243 as
                            amemded at 836th BOR Meeting: 30 Aug 1973, 990th BOR Meeting: 28 Aug 1986).” [For graduate students, refer to General Rules for Graduate
                            Programs part, of this Section].
                        </Typography>
                    </Grid>
                </Grid>
            <FooterDefault /> 
        </ThemeProvider>
    )
}

export default MRR